import { QueryParam } from "../../../types/api/generic.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import HttpClient from "../../client/HttpClient";
import { downloadFileFromUrl } from "../../../utils/downloadFile.utils";

const CollaboratorsCurriculumsService = {
  async get(queryParams: QueryParam[]): Promise<ArrayBuffer> {
    const params = queryParams ? createQueryParamString(queryParams, true) : "";

    const response: ArrayBuffer = await HttpClient.get(
      `v1/collaborators/curriculums${params}`,
      { responseType: "arraybuffer" },
    );
    return response;
  },
  async download(queryParams: QueryParam[]): Promise<void> {
    const params = queryParams ? createQueryParamString(queryParams, true) : "";
    downloadFileFromUrl(
      `v1/collaborators/curriculums${params}&isToNotify=true`,
    );
  },
};

export default CollaboratorsCurriculumsService;
